import { twMerge } from "tailwind-merge";
import { useTheme } from "../hooks/useTheme";
import { ButtonSimple } from "./RtfmDemoApp.js";
import { SunIcon } from "@phosphor-icons/react";

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle = ({ className }: ThemeToggleProps) => {
  const { theme, toggle } = useTheme();

  return (
    <ButtonSimple
      onClick={toggle}
      aria-label="Toggle color theme"
      className={twMerge(
        "min-w-min border-none w-min text-[1.5em] p-0",
        className,
      )}
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    >
      <span aria-hidden>{theme === "dark" ? <SunIcon /> : <SunIcon />}</span>
    </ButtonSimple>
  );
};

ThemeToggle.displayName = "ThemeToggle";
